// Conversión entre filas editables [{key, value}] y el dict que guarda el backend
// (headers, query params). Las filas con clave vacía se descartan.
export const rowsToDict = (rows = []) =>
  rows.reduce((acc, { key, value }) => {
    const k = (key || "").trim();
    if (k) acc[k] = value ?? "";
    return acc;
  }, {});

// Steps viejos pueden traer el dict guardado como texto JSON (el textarea
// anterior caía a string si el JSON era inválido). Se interpreta si es un objeto
// JSON; cualquier otra cosa (texto suelto, array) no se trocea carácter por carácter.
const asPlainObject = (value) => {
  let v = value;
  if (typeof v === "string") {
    try {
      v = JSON.parse(v);
    } catch {
      return {};
    }
  }
  return v && typeof v === "object" && !Array.isArray(v) ? v : {};
};

export const dictToRows = (dict) =>
  Object.entries(asPlainObject(dict)).map(([key, value]) => ({ key, value: value == null ? "" : String(value) }));
